import { Autocomplete, Box, Grid, MenuItem, TextField, Typography } from '@mui/material';
import { FilterContainer } from 'src/components/FilterDrawer';

export interface CaseFilterOption {
  value: string;
  label: string;
}

export interface CaseFiltersListValues {
  workflowStatus: string;
  workflowStageName: string;
  assignedTo: string[];
}

type Props = {
  values: CaseFiltersListValues;
  onChange: (
    key: keyof CaseFiltersListValues,
    value: string | string[]
  ) => void;
  statusOptions?: CaseFilterOption[];
  stageOptions?: CaseFilterOption[];
  users?: any[];
  i18n: (key: string, ns?: string) => string;
};

/** Fallback used only until the list response provides actual status values. */
const DEFAULT_STATUS_OPTIONS: CaseFilterOption[] = [
  { value: 'Open', label: 'Open' },
  { value: 'Closed', label: 'Closed' },
];

export default function CaseFiltersList({
  values,
  onChange,
  statusOptions = [],
  stageOptions = [],
  users = [],
  i18n,
}: Props) {
  const statusSource = statusOptions.length ? statusOptions : DEFAULT_STATUS_OPTIONS;
  const statusOptionsMerged: CaseFilterOption[] = [
    { value: '', label: 'All' },
    ...statusSource.filter((o) => o.value !== ''),
  ];

  const stageOptionsMerged: CaseFilterOption[] = [
    { value: '', label: 'All' },
    ...stageOptions.filter((o) => o.value !== ''),
  ];

  return (
    <Box py={3}>
      <Grid item xs={12}>
        <FilterContainer label={i18n('case.list.filterPopUp.status', 'crs')}>
          <TextField
            select
            fullWidth
            size="small"
            value={values.workflowStatus}
            onChange={(e) => onChange('workflowStatus', e.target.value)}
          >
            {statusOptionsMerged.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterContainer>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <FilterContainer label={i18n('case.list.filterPopUp.stage', 'crs')}>
          <TextField
            select
            fullWidth
            size="small"
            value={values.workflowStageName}
            onChange={(e) => onChange('workflowStageName', e.target.value)}
          >
            {stageOptionsMerged.map((opt) => (
              <MenuItem key={opt.value || 'all'} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </FilterContainer>
      </Grid>

      <Grid item xs={12} sx={{ marginTop: 2 }}>
        <Typography fontSize={'1rem'} fontWeight={'bold'} marginBottom={1}>
          {i18n('case.list.filterPopUp.assignedTo', 'crs')}
        </Typography>
        <Autocomplete
          value={values.assignedTo ?? []}
          multiple
          fullWidth
          onChange={(_: React.SyntheticEvent, assignedTo) => {
            onChange('assignedTo', [...assignedTo]);
          }}
          options={users?.map((option: any) => option?.email)}
          getOptionLabel={(option: string) => option}
          renderInput={(params) => (
            <TextField
              {...params}
              label={i18n('case.list.filterPopUp.assignedTo', 'crs')}
              variant="outlined"
            />
          )}
        />
      </Grid>
    </Box>
  );
}
